import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollEmployeeFieldAccessRolesResponse } from '../types';

export const listEmployeeFieldAccessRolesQuery = gql`
  query PayrollEmployeeDataFieldAccessRoles {
    payrollEmployeeDataFieldAccessRoles {
      data {
        id
        name
        memberCount
        access
        locked
      }
      code
      success
      message
    }
  }
`;

export const listEmployeeFieldAccessRoles = () =>
  graphQLApi<PayrollEmployeeFieldAccessRolesResponse, {}>({
    query: listEmployeeFieldAccessRolesQuery,
    queryVariables: {},
  });
